import React, { useEffect } from 'react'
import { Button } from '@material-ui/core'
import { Checkbox, FormControlLabel } from '@material-ui/core'
import thumbnail from '../../assets/images/default-thumbnail.jpg'
import { dateFormatFront, currencyFormat } from '@/custom/common/components'
const EMDSelectionComponent = (props) => {
    const formikPayment = props.formik
    // useEffect(() => {}, [formikPayment.values?.payment_lot_ids])
    // console.log(
    //     'ooooooooooooooooooooo',
    //     formikPayment.values?.payment_lot_ids,
    //     props.flag,
    //     formikPayment.values?.payment_lot_ids?.includes(props.flag),
    // )
    const changeFun = (e) => {
        const value = e.target.value.toString()
        const selected = formikPayment.values?.payment_lot_ids || []
        const flagId = props.flag?.toString()

        let updated = []

        const isChecked = selected.includes(value)

        if (value === flagId) {
            // User clicked on flag
            if (isChecked) {
                // Uncheck flag
                updated = []
            } else {
                // Select flag, remove all others
                updated = [flagId]
            }
        } else {
            // User clicked on a non-flag item
            if (isChecked) {
                // Uncheck the item
                updated = selected.filter((id) => id !== value)
            } else {
                // Add item, and ensure flag is removed
                updated = [...selected.filter((id) => id !== flagId), value]
            }
        }

        formikPayment.setFieldValue('payment_lot_ids', updated)
    }

    return (
        <div className="checkDetailsParent">
            <h3>Select your EMD for the Auction Registration</h3>
            <div className="checkImgCnt">
                <img
                    src={
                        props.auction.auctionlot_avatar
                            ? `${global.site_url}/uploads/auction/${props.auction.auctionlot_avatar}`
                            : thumbnail
                    }
                    alt="checkout"
                    className="checkImg"
                />
            </div>
            <div className="checkImgCnt mt-3">
                <h4>{props.auction?.auctionlot_title}</h4>
                <ul>
                    <li>
                        <span>Auction ID :</span>
                        <label>{props.auction?.auction_id}</label>
                    </li>
                    <li>
                        <span>Start Date & Time :</span>
                        <label>{dateFormatFront(props.auction?.auctionlot_date_added)}</label>
                    </li>
                    {/* <li>
                        <span>Lots :</span>
                        <label className="active">View Lot Details</label>
                    </li> */}
                </ul>
            </div>
            <div className="d-flex justify-content-end mt-3">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        formikPayment.setFieldValue('payment_lot_ids', [])
                    }}
                    style={{ background: '#094fa3', textTransform: 'none' }}
                    className="resetButton"
                >
                    Reset EMD Selection
                </Button>
            </div>
            {props?.list?.map((data) => (
                <div className="checkImgCnt mt-3 pb-1" key={data.id}>
                    <div className="auctionCards">
                        <div className="checkboxContainer">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="payment_lot_ids"
                                        checked={formikPayment.values?.payment_lot_ids?.includes(
                                            data.id.toString(),
                                        )}
                                        value={data.id.toString()}
                                        onChange={changeFun}
                                        color="primary"
                                    />
                                }
                                label={
                                    <span className="checkboxLabel">
                                        {data.is_entire_auction
                                            ? 'Select to pay for entire auction'
                                            : 'Select to pay for Lot number(s)'}
                                    </span>
                                }
                            />
                        </div>
                        <div>{data.lot_number}</div>
                        <div>{currencyFormat(data.amount)}</div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default EMDSelectionComponent
